document.addEventListener('change', async function (event) {
  const checkbox = event.target.closest('[data-gift-wrap]');
  if (!checkbox) return;

  const variantId = Number(checkbox.dataset.giftWrapVariant);

  checkbox.disabled = true;

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const giftWrap = cart.items.find(
      item => Number(item.variant_id) === variantId
    );

    if (checkbox.checked) {
      // Don't add another Gift Wrap if one already exists
      if (!giftWrap) {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1
            }]
          })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Could not add gift wrap');
        }
      }
    } else {
      // Remove Gift Wrap
      if (giftWrap) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: giftWrap.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Could not remove gift wrap');
        }
      }
    }

    // Refresh the cart
    window.location.reload();

  } catch (error) {
    console.error('Gift Wrap Error:', error);
    alert(error.message);
    checkbox.checked = !checkbox.checked;
    checkbox.disabled = false;
  }
});